'use strict'

import SelectManager from 'assets/core/js/module/selectManager'

export default function (): void {
  document.querySelectorAll('.dashboard__filters-reset').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()

      document
        .getElementById('dashboard-form')
        ?.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input, select')
        .forEach((el) => {
          if (el.nodeName === 'SELECT') {
            SelectManager.setValue(el.id, '')
          } else {
            el.value = ''
          }
        })
    })
  })
}
